<template>
  <div class="calculator-input__wrapper">
    <div
        class="calculator-input"
        :class="{
        'is-loading': isLoadingToggle,
      }"
    >
      <input
          v-imask="input.maskSettings"
          placeholder="0"
          :value="input.amountString"
          class="calculator-input__input"
          :class="{ 'is-updating': isPriceUpdateInProgress }"
          pattern="^[0-9]+([\.,][0-9]+)?$"
          inputmode="decimal"
          @accept="onAccept"
          :data-testid="dataTestid"
          ref="input"
      />
      <CalculatorInputOptions
          :is-crypto="input.isCrypto()"
          :selected-option="input.currency.code"
          :items="currencies"
          @change="handleOptionChange"
          @is-open="$emit('option-is-open')"
          data-testid="currencydropdown"
      />
      <div class="calculator-input-loader"></div>
    </div>
  </div>
</template>

<script>
import { IMaskDirective } from 'vue-imask';
import { mapState } from 'vuex';

import CalculatorInputOptions from '@/components/Calculator/CalculatorInputOptions.vue';


export default {
  name: 'CalculatorInput',

  components: {
    CalculatorInputOptions,
  },

  directives: {
    imask: IMaskDirective,
  },

  props: {
    input: { type: Object, required: true },
    currencies: { type: Array, required: true },
    isLoading: { type: Boolean, required: true },
    dataTestid: { type: String, required: false, default: null },
  },

  data () {
    return {
      isLoadingToggle: this.isLoading,
    };
  },

  watch: {
    isLoading () {
      this.isLoadingToggle = this.isLoading;
    },
  },

  computed: {
    ...mapState('calculator', ['isPriceUpdateInProgress']),
  },

  methods: {
    handleOptionChange (selectedOption) {
      this.$emit('option-change', selectedOption);
    },
    onAccept (e) {
      const value = e.detail.value;

      if (this.input.amountString !== value && Number.parseFloat(this.input.amountString) !== Number.parseFloat(value)) {
        this.$emit('input-change', value);
      }
    },
  },
};
</script>
